import React, { useState } from "react";

// Image with graceful fallback to a soft branded gradient block.
const Img = ({ src, alt, className, fallbackClass = "", ...rest }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div
        className={`${className} ${fallbackClass}`}
        style={{
          background:
            "linear-gradient(135deg, #EFEDE7 0%, #e3ddcf 50%, #d8c9b5 100%)",
        }}
        aria-label={alt}
        role="img"
        {...rest}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default Img;
